import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'filterJobByType',
})
export class FilterJobByType<T extends any> implements PipeTransform {
  constructor() {}

  public transform(items: T[], filters: {}): T[] {
    if (!items || !filters) {
      return items;
    }
    return items.filter(item =>
      Object.keys(filters).every(key => filters[key] === item[key])
    );
  }
}
